import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "download-accuracy-rate-modal__forecast-name" }
const _hoisted_2 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_3 = { class: "download-accuracy-rate-modal-content__main-content main-content" }

import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import { i18n } from '@/i18n';
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadAccuracyRateModal',
  props: {
    store: {},
    defaultStartYearMonth: {},
    defaultEndYearMonth: {}
  },
  setup(__props: any) {

const props = __props;

// 変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

const { state } = storeToRefs(props.store);

onMounted(() => {
  state.value.downloadModalState.startYearMonth = props.defaultStartYearMonth;
  state.value.downloadModalState.endYearMonth = props.defaultEndYearMonth;
});

/**
 * モーダルの表示状態
 */
const modalState = computed({
  /**
   * getter
   * @returns モーダルの表示状態
   */
  get: () => {
    return state.value.downloadModalState.isOpen;
  },
  /**
   * setter
   * @param value - 設定する値
   */
  set: (value) => {
    state.value.downloadModalState.isOpen = value;
    if (value) {
      // Reset to default values when modal opens
      state.value.downloadModalState.startYearMonth = props.defaultStartYearMonth;
      state.value.downloadModalState.endYearMonth = props.defaultEndYearMonth;
    }
  },
});

const isInvalidYearMonth = computed(() => {
  if (
    !DateService.validIYearMonth(state.value.downloadModalState.startYearMonth) ||
    !DateService.validIYearMonth(state.value.downloadModalState.endYearMonth)
  )
    return '年月を入力してください';

  const diff = DateService.calculateIYearMonthsDiff(
    state.value.downloadModalState.endYearMonth,
    state.value.downloadModalState.startYearMonth
  );
  if (diff < 0) return '開始年月より終了年月が前になっています';
  if (diff > 23) return '24ヶ月を超える期間は指定できません';
  return 'valid';
});

/**
 * 開始年月選択時の処理
 * @param yearMonth - 選択された年月
 */
const onSelectedStartYearMonth = (yearMonth: IYearMonth) => {
  state.value.downloadModalState.startYearMonth = yearMonth;
};

/**
 * 終了年月選択時の処理
 * @param yearMonth - 選択された年月
 */
const onSelectedEndYearMonth = (yearMonth: IYearMonth) => {
  state.value.downloadModalState.endYearMonth = yearMonth;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": modalState.value,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('ダウンロード'),
    "is-disabled-next-button": isInvalidYearMonth.value !== 'valid',
    onOnBack: _cache[2] || (_cache[2] = ($event: any) => (modalState.value = false)),
    onOnNext: _cache[3] || (_cache[3] = ($event: any) => (_ctx.store.onDownloadApply(_unref(state).downloadModalState.startYearMonth, _unref(state).downloadModalState.endYearMonth)))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('内示正答率のダウンロード')), 1)
    ]),
    description: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(_unref(t)('下記から出力期間を選んでください')), 1),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(state).downloadModalState.targetForecastName), 1)
    ]),
    default: _withCtx(() => [
      (isInvalidYearMonth.value !== 'valid')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)(isInvalidYearMonth.value)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MonthPicker, {
          class: "main-content__calendar download-accuracy-rate-calendar",
          "model-value": _unref(state).downloadModalState.startYearMonth,
          locale: locale.value,
          "prop-format": _unref(t)('MonthPickerFormat'),
          "max-date": _unref(state).downloadModalState.endYearMonth,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onSelectedStartYearMonth($event)))
        }, null, 8, ["model-value", "locale", "prop-format", "max-date"]),
        _createTextVNode(" " + _toDisplayString(_unref(t)('から')) + " ", 1),
        _createVNode(MonthPicker, {
          class: "main-content__calendar download-accuracy-rate-calendar",
          "model-value": _unref(state).downloadModalState.endYearMonth,
          locale: locale.value,
          "prop-format": _unref(t)('MonthPickerFormat'),
          "min-date": _unref(state).downloadModalState.startYearMonth,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (onSelectedEndYearMonth($event)))
        }, null, 8, ["model-value", "locale", "prop-format", "min-date"]),
        _createTextVNode(" " + _toDisplayString(_unref(t)('まで')), 1)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})